import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { grey5 } from 'approot/shared/styles/colours.style';

export const TeacherDownloadOptions = styled.div`
  border-left: 1px solid ${grey5};
  top: 0;
  right: 0;
  bottom: ${rem(90)};
  padding: ${rem(spacing16)};
  position: absolute;
  width: ${rem(300)};
`;

export const TeacherDownloadContent = styled.div`
  overflow: auto;
  overflow-x: hidden;
  position: relative;
  height: 100%;

  ${mediaUp.sm`
    margin-right: ${rem(300)};
  `}
`;

export const TeacherDownloadItem = styled.li`
  width: 100%;

  ${mediaUp.md`
    width: calc((100% - ${rem(spacing16)}) / 2);
  `}
`;
